import { BaseEdge, EdgeLabelRenderer, type EdgeProps, getSmoothStepPath } from '@xyflow/react'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { FlowActionDropdown } from 'widgets/Flow'
import { FlowBranchLabel } from 'widgets/Flow/ui/FlowBranchLabel/FlowBranchLabel'
import { FlowBranchAction } from 'widgets/Flow/ui/FlowBranchAction/FlowBranchAction'

import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { getActions } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/CustomEdge/getActions'
import { AddActionDropdownContent } from './AddActionDropdownContent/AddActionDropdownContent'

export const CustomEdgeWithLabel = observer(
  ({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    source,
    target,
    disabled,
  }: EdgeProps & { disabled?: boolean }) => {
    const [edgePath] = getSmoothStepPath({
      sourceX,
      sourceY,
      targetX,
      targetY,
      borderRadius: 12,
      centerY: sourceY + 36,
    })

    const { getActionById } = useSmartCallFlowBuilderContext()

    const sourceAction = getActionById(source)

    const [open, setOpen] = useState(false)

    if (!sourceAction) {
      return null
    }

    const branchLabelX = targetX
    const branchLabelY = sourceY + 84

    const addButtonX = targetX
    const addButtonY = (branchLabelY + 18 + targetY) / 2

    const label =
      ('getBranchNameByTargetId' in sourceAction && sourceAction.getBranchNameByTargetId(target)) ||
      ''

    const actions = getActions({ getActionById, source, target })

    return (
      <>
        <BaseEdge
          id={id}
          path={edgePath}
          style={{
            strokeWidth: 2,
            stroke: disabled ? 'var(--content-primary-disabled)' : 'var(--light-blue-60)',
          }}
        />
        <EdgeLabelRenderer>
          <FlowBranchLabel
            labelX={branchLabelX}
            labelY={branchLabelY}
            label={label || ''}
            disabled={disabled}
          />
          {!!actions.length && (
            <>
              <FlowBranchAction
                labelX={addButtonX}
                labelY={addButtonY}
                open={open}
                onClick={() => setOpen(!open)}
                disabled={disabled}
              />

              {open && (
                <FlowActionDropdown
                  setOpen={setOpen}
                  transform={`translateX(-50%) translate(${addButtonX}px, ${addButtonY + 12}px)`}
                  width={231}
                >
                  <AddActionDropdownContent
                    setOpen={setOpen}
                    actions={actions}
                    target={target}
                    source={source}
                  />
                </FlowActionDropdown>
              )}
            </>
          )}
        </EdgeLabelRenderer>
      </>
    )
  }
)
